import {
  ApiClassification,
  ApiClassificationItem,
  ApiClassificationItemPayload,
  ApiClassificationRulePayload,
  ApiProject,
} from "@incendium/api";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { audienceService } from "Apis";
import CustomDialog from "Components/CustomDialog/CustomDialog";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

function ClassificationItemDialog({
  onClose,
  onSaved,
  classification,
  classificationItem,
  project,
}: {
  onClose: () => void;
  onSaved: (c: ApiClassificationItem) => void;
  classification?: ApiClassification | null;
  classificationItem?: ApiClassificationItem | null;
  project: ApiProject;
}) {
  const [value, setValue] = useState(classificationItem?.value || "");
  const [description, setDescription] = useState(
    classificationItem?.description || ""
  );

  const [order] = useState(
    classificationItem?.order ||
      (classification?.classificationItems || []).length + 1
  );
  const [disabled, setDisabled] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async () => {
    setDisabled(true);

    const rulesPayload: ApiClassificationRulePayload[] = (
      classificationItem?.rules || []
    ).map((r) => ({
      ...r,
      condition: undefined,
    }));

    let payload: ApiClassificationItemPayload = {
      value,
      description,
      order,
      rules: rulesPayload,
    };
    try {
      const fn =
        classificationItem && classificationItem.id
          ? audienceService.audienceServiceUpdateClassificationItem({
              projectId: project.id as number,
              classificationId: classification?.id as number,
              classificationItemId: classificationItem.id,
              payload,
            })
          : audienceService.audienceServiceCreateClassificationItem({
              projectId: project.id as number,
              classificationId: classification?.id as number,
              payload,
            });
      const res = await fn;
      enqueueSnackbar(`${res.value} Saves`, {
        variant: "success",
        autoHideDuration: 2000,
        anchorOrigin: { horizontal: "right", vertical: "top" },
      });
      onSaved(res);
    } catch (error) {
      enqueueSnackbar("Something Went Wrong", {
        variant: "error",
        autoHideDuration: 2000,
        anchorOrigin: { horizontal: "right", vertical: "top" },
      });
    }
    setDisabled(false);
  };

  return (
    <CustomDialog onClose={onClose} fullWidth maxWidth="sm" open>
      <ValidatorForm onSubmit={onSubmit}>
        <DialogTitle>
          {classificationItem
            ? `Edit ${classificationItem.value}`
            : `Add New Classification Value`}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextValidator
                variant="outlined"
                fullWidth
                name="name"
                autoFocus={true}
                label="Classification Item Value *"
                value={value}
                disabled={disabled}
                validators={["required"]}
                errorMessages={["Classification Item Value is required"]}
                onChange={(e: any) => setValue(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextValidator
                variant="outlined"
                fullWidth
                name="description"
                label="Classification Item Description "
                value={description}
                disabled={disabled}
                multiline
                rows={3}
                rowsMax={8}
                validators={["maxStringLength:1000"]}
                errorMessages={[
                  "Classification Item description can only be 1000 characters long",
                ]}
                onChange={(e: any) => setDescription(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button disabled={disabled} onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button
            disabled={disabled}
            variant="contained"
            color="primary"
            type="submit"
          >
            {classificationItem ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </ValidatorForm>
    </CustomDialog>
  );
}

export default ClassificationItemDialog;
